import React from 'react';
import { useCopilot } from '../../hooks/useCopilot';
import useTranslation from '../../hooks/useTranslation';
import OnXHeader from '../../components/onx/OnXHeader';
import OnXMessageList from '../../components/onx/OnXMessageList';
import OnXInput from '../../components/onx/OnXInput';

/**
 * OnX : le chat IA en pleine page. Meme moteur que Pilot (useCopilot,
 * pilot_conversations / pilot_messages, Edge Function pilot-chat), sans projet
 * ouvert : mode organisation, tous les projets autorises.
 *
 * La page occupe la hauteur de la zone de contenu ; seule la liste des
 * messages defile.
 */
const OnXPage = () => {
  const { t } = useTranslation();
  const { messages, sendMessage, isLoading, error, startNewConversation, isInitialized } = useCopilot(null, null, true);

  // Accueil affiche quand la conversation est vide. Jamais enregistre ni envoye
  // dans l'historique : il ne vit que dans cet affichage.
  const shown = isInitialized && messages.length === 0
    ? [{ role: 'assistant', content: t('onx.greeting'), timestamp: 'greeting' }]
    : messages;

  return (
    <div className="h-full min-h-0 flex flex-col bg-background rounded-xl border border-gray-200 overflow-hidden">
      <OnXHeader onNewConversation={startNewConversation} disabled={isLoading || messages.length === 0} />
      <OnXMessageList messages={shown} isLoading={isLoading} error={error} />
      <OnXInput onSend={sendMessage} isLoading={isLoading || !isInitialized} />
    </div>
  );
};

export default OnXPage;
